import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import AuthRegisterAuthCodeView from './auth-register-auth-code.component.html';

const VERIFY_ERROR = 'El código de verificación no es válido.';

@Component({
    selector: 'auth-register-auth-code',
    template: AuthRegisterAuthCodeView
})
export class AuthRegisterAuthCodeComponent implements OnInit {

    userToken: string;
    showQr = false;
    qrCode = '';
    code = '';
    errorMessage: string | null = null;
    showNewLogin = false;
    companyLogoUrl = '';
    companyName = '';
    showCompanyData = false;
    successState = false;
    continueLogin = false;

    constructor(
        @Inject('$stateParams') private $stateParams: any,
        @Inject('$state') private $state: any,
        @Inject(HttpClient) private http: HttpClient
    ) {
        this.userToken = this.$stateParams.token;
    }

    ngOnInit(): void {
        this.http.get<number>('/api/Companies/Count').subscribe({
            next: (count) => {
                if (count !== 0) {
                    this.showCompanyData = true;
                    this.companyLogoUrl = `/api/Companies/${count}/logo`;
                    this.http.get<string>(`/api/Companies/${count}/name`).subscribe({
                        next: (name) => { this.companyName = name; }
                    });
                }
            },
            complete: () => { this.showNewLogin = true; }
        });

        this.http.get<{ success: boolean; image?: string }>(`/api/Auth/AuthenticatorQRCode/${this.userToken}`).subscribe({
            next: (result) => {
                this.showQr = result.success;
                if (result.success && result.image) {
                    this.qrCode = result.image;
                }
            },
            error: (error) => {
                this.errorMessage = error?.error?.message || VERIFY_ERROR;
            }
        });
    }

    verifyCode(): void {
        this.errorMessage = null;
        if (this.code.length !== 6) {
            this.errorMessage = VERIFY_ERROR;
            return;
        }
        this.http.post<{ success: boolean; continueLogin?: boolean }>(
            `/api/Auth/Authenticator/Verify/${this.code}/${this.userToken}`, {}
        ).subscribe({
            next: (result) => {
                if (result.success) {
                    this.continueLogin = result.continueLogin === true;
                    this.successState = true;
                } else {
                    this.errorMessage = VERIFY_ERROR;
                }
            },
            error: (error) => {
                this.errorMessage = error?.error?.message || VERIFY_ERROR;
            }
        });
    }

    advance(): void {
        this.$state.go(this.continueLogin ? 'authinit' : 'login');
    }

    resetProcess(): void {
        this.http.post('/api/Auth/Reset', {}).subscribe({
            complete: () => this.$state.go('authinit', {}, { reload: true })
        });
    }
}
